document.addEventListener('DOMContentLoaded',()=>{
  const search=document.querySelector('[data-search-panel]');
  document.querySelectorAll('[data-search-toggle]').forEach(b=>b.addEventListener('click',()=>{search?.classList.toggle('open');search?.querySelector('input')?.focus()}));
  const menu=document.querySelector('[data-mobile-menu]');
  const overlay=document.querySelector('[data-menu-overlay]');
  const cartDrawer=document.getElementById('cart-drawer');
  const closeDrawers=()=>{menu?.classList.remove('open');cartDrawer?.classList.remove('open');overlay?.classList.remove('open')};
  const openMenu=()=>{cartDrawer?.classList.remove('open');menu?.classList.add('open');overlay?.classList.add('open')};
  const openCart=()=>{menu?.classList.remove('open');cartDrawer?.classList.add('open');overlay?.classList.add('open')};
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-menu-toggle]')){menu?.classList.contains('open')?closeDrawers():openMenu();return}
    const openBtn=e.target.closest('[data-cart-open]');
    if(openBtn){e.preventDefault();openCart();return}
    const closeBtn=e.target.closest('[data-cart-close]');
    if(closeBtn&&closeBtn.tagName!=='A'){e.preventDefault();closeDrawers()}
  });
  overlay?.addEventListener('click',closeDrawers);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawers()});
  async function refreshCartDrawer(){
    const res=await fetch('/?sections=cart-drawer');
    const data=await res.json();
    const html=data['cart-drawer'];
    if(cartDrawer&&html){
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.getElementById('cart-drawer');
      if(fresh)cartDrawer.innerHTML=fresh.innerHTML;
    }
  }
  async function finishAddToCart(){
    const cart=await fetch('/cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
    await refreshCartDrawer();
    openCart();
  }
  async function addToCart(form){
    const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    if(!res.ok)throw new Error();
    await finishAddToCart();
  }
  async function addItemsToCart(items){
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
    if(!res.ok)throw new Error();
    await finishAddToCart();
  }
  async function refreshCartPage(){
    const cartPage=document.querySelector('[data-cart-page]');
    if(!cartPage)return;
    const res=await fetch(window.location.pathname+'?sections=main');
    const data=await res.json();
    const html=data['main'];
    if(html){
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('[data-cart-page]');
      if(fresh)cartPage.innerHTML=fresh.innerHTML;
    }
  }
  async function changeCartLine(key,quantity){
    const res=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})});
    if(!res.ok)throw new Error();
    const cart=await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
    await refreshCartPage();
    await refreshCartDrawer();
  }
  document.addEventListener('click',e=>{
    const line=e.target.closest('[data-cart-line]');
    if(!line)return;
    const key=line.dataset.key;
    const input=line.querySelector('[data-cart-qty-input]');
    if(e.target.closest('[data-cart-remove]')){
      changeCartLine(key,0).catch(()=>toast('Could not remove item'));
    }else if(e.target.closest('[data-cart-qty-decrease]')){
      changeCartLine(key,(parseInt(input.value,10)||1)-1).catch(()=>toast('Could not update quantity'));
    }else if(e.target.closest('[data-cart-qty-increase]')){
      changeCartLine(key,(parseInt(input.value,10)||1)+1).catch(()=>toast('Could not update quantity'));
    }
  });
  document.addEventListener('change',e=>{
    const input=e.target.closest('[data-cart-qty-input]');
    if(!input)return;
    const line=e.target.closest('[data-cart-line]');
    changeCartLine(line.dataset.key,parseInt(input.value,10)||0).catch(()=>toast('Could not update quantity'));
  });
  document.querySelector('[data-variant-options]')?.addEventListener('click',e=>{
    const pill=e.target.closest('.variant-pill');
    if(!pill||pill.disabled)return;
    const group=pill.closest('[data-variant-options]');
    group.querySelectorAll('.variant-pill').forEach(p=>p.classList.remove('active'));
    pill.classList.add('active');
    const input=document.getElementById('variant-select');
    if(input)input.value=pill.dataset.variantId;
    if(pill.dataset.mediaIndex!==undefined){
      document.querySelector('[data-gallery]')?._goToSlide?.(Number(pill.dataset.mediaIndex));
    }
  });
  const upsellRoot=document.querySelector('[data-upsell]');
  function upsellItemEls(){return upsellRoot?Array.from(upsellRoot.querySelectorAll('[data-upsell-item]')):[]}
  function getMainQty(){return parseInt(document.getElementById('qty-input')?.value,10)||1}
  function getUpsellQty(el){return parseInt(el.querySelector('[data-upsell-qty-value]').textContent,10)||0}
  function setUpsellQty(el,qty){el.querySelector('[data-upsell-qty-value]').textContent=Math.max(0,qty)}
  function updateUpsellStatus(){
    if(!upsellRoot)return;
    const status=upsellRoot.querySelector('[data-upsell-status]');
    const extras=upsellItemEls().reduce((sum,el)=>sum+getUpsellQty(el),0);
    const total=getMainQty()+extras;
    if(status){
      if(total>=3)status.textContent="You're saving 50% on your 3rd item!";
      else if(total===2)status.textContent="You're saving 25% on your 2nd item!";
      else status.textContent='Add 1 more item to save 25%';
    }
    upsellRoot.querySelectorAll('[data-upsell-tier]').forEach(btn=>{
      btn.classList.toggle('active',Number(btn.dataset.upsellTier)===total);
    });
  }
  upsellRoot?.addEventListener('click',e=>{
    const incBtn=e.target.closest('[data-upsell-qty-increase]');
    const decBtn=e.target.closest('[data-upsell-qty-decrease]');
    const tierBtn=e.target.closest('[data-upsell-tier]');
    if(incBtn){
      const item=incBtn.closest('[data-upsell-item]');
      setUpsellQty(item,getUpsellQty(item)+1);
      updateUpsellStatus();
    }else if(decBtn){
      const item=decBtn.closest('[data-upsell-item]');
      setUpsellQty(item,getUpsellQty(item)-1);
      updateUpsellStatus();
    }else if(tierBtn){
      const tier=Number(tierBtn.dataset.upsellTier);
      const items=upsellItemEls();
      const needed=Math.max(0,tier-getMainQty());
      items.forEach((el,i)=>setUpsellQty(el,i===0?needed:0));
      updateUpsellStatus();
    }else{
      const variantPill=e.target.closest('.upsell-variant-pill');
      if(variantPill&&!variantPill.disabled){
        const item=variantPill.closest('[data-upsell-item]');
        item.querySelectorAll('.upsell-variant-pill').forEach(p=>p.classList.remove('active'));
        variantPill.classList.add('active');
        item.dataset.variantId=variantPill.dataset.variantId;
      }
    }
  });
  updateUpsellStatus();
  document.querySelector('[data-upsell-add]')?.addEventListener('click',async e=>{
    const btn=e.target;
    const mainForm=document.getElementById('product-form');
    const mainId=mainForm?.querySelector('[name=id]');
    const mainQty=mainForm?.querySelector('[name=quantity]');
    if(!mainId)return;
    const items=[{id:Number(mainId.value),quantity:Number(mainQty?.value)||1}];
    upsellItemEls().forEach(el=>{
      const qty=getUpsellQty(el);
      if(qty>0)items.push({id:Number(el.dataset.variantId),quantity:qty});
    });
    const original=btn.textContent;
    btn.disabled=true;btn.textContent='Adding…';
    try{await addItemsToCart(items);btn.textContent='Added ✓'}
    catch{toast('Could not add items')}
    setTimeout(()=>{btn.disabled=false;btn.textContent=original},1200);
  });
  function toast(msg){const t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2200)}
  document.querySelectorAll('[data-qty-decrease]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=btn.parentElement.querySelector('[data-qty-input]');
    input.value=Math.max(1,(parseInt(input.value,10)||1)-1);
    updateUpsellStatus();
  }));
  document.querySelectorAll('[data-qty-increase]').forEach(btn=>btn.addEventListener('click',()=>{
    const input=btn.parentElement.querySelector('[data-qty-input]');
    input.value=(parseInt(input.value,10)||1)+1;
    updateUpsellStatus();
  }));
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-quick-add]');
    if(!form)return;
    e.preventDefault();
    const btn=form.querySelector('button');
    btn.disabled=true;btn.textContent='Adding…';
    try{await addToCart(form);btn.textContent='Added ✓'}
    catch{toast('Could not add item')}
    setTimeout(()=>{btn.disabled=false;btn.textContent='Quick add'},1200);
  });
  document.getElementById('product-form')?.addEventListener('submit',async e=>{
    e.preventDefault();
    const form=e.target;
    const btn=form.querySelector('[type=submit]');
    const original=btn.textContent;
    btn.disabled=true;btn.textContent='Adding…';
    try{await addToCart(form)}
    catch{toast('Could not add item')}
    btn.disabled=false;btn.textContent=original;
  });
  document.querySelectorAll('[data-buy-now]').forEach(btn=>btn.addEventListener('click',async()=>{
    const form=btn.closest('form');
    if(!form)return;
    const originalText=btn.textContent;
    btn.disabled=true;btn.textContent='Processing…';
    try{
      const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!res.ok)throw new Error();
      window.location.href='/checkout';
    }catch{
      toast('Could not start checkout');
      btn.disabled=false;btn.textContent=originalText;
    }
  }));
  document.querySelectorAll('[data-tabs]').forEach(wrap=>{
    const btns=[...wrap.querySelectorAll('[data-tab-btn]')];
    const panels=[...wrap.querySelectorAll('[data-tab-panel]')];
    btns.forEach(btn=>btn.addEventListener('click',()=>{
      btns.forEach(b=>{b.classList.remove('active');b.setAttribute('aria-selected','false')});
      panels.forEach(p=>p.classList.remove('active'));
      btn.classList.add('active');
      btn.setAttribute('aria-selected','true');
      wrap.querySelector('[data-tab-panel][data-tab="'+btn.dataset.tab+'"]')?.classList.add('active');
    }));
  });
  document.querySelectorAll('[data-collection-sort] select').forEach(s=>s.addEventListener('change',()=>s.form.submit()));
  document.querySelectorAll('[data-gallery]').forEach(gal=>{
    const track=gal.querySelector('[data-gallery-track]');
    const slides=[...track.children];
    const thumbs=[...gal.querySelectorAll('[data-gallery-thumb]')];
    const current=()=>slides.reduce((closest,s,i)=>Math.abs(s.offsetLeft-track.scrollLeft)<Math.abs(slides[closest].offsetLeft-track.scrollLeft)?i:closest,0);
    const go=i=>track.scrollTo({left:slides[Math.max(0,Math.min(slides.length-1,i))].offsetLeft,behavior:'smooth'});
    gal._goToSlide=go;
    gal.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>go(current()-1));
    gal.querySelector('[data-gallery-next]')?.addEventListener('click',()=>go(current()+1));
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>go(i)));
    if(thumbs[0])thumbs[0].classList.add('active');
    const counter=gal.querySelector('[data-gallery-counter-current]');
    let ticking=false;
    track.addEventListener('scroll',()=>{
      if(ticking)return;ticking=true;
      requestAnimationFrame(()=>{const i=current();thumbs.forEach((t,idx)=>t.classList.toggle('active',idx===i));if(counter)counter.textContent=i+1;ticking=false});
    });
  });
  document.querySelectorAll('[data-share]').forEach(share=>{
    const url=share.dataset.url;const title=share.dataset.title;
    const toggle=share.querySelector('[data-share-toggle]');
    toggle?.addEventListener('click',e=>{
      e.stopPropagation();
      const open=share.classList.toggle('open');
      toggle.setAttribute('aria-expanded',open?'true':'false');
    });
    document.addEventListener('click',()=>{share.classList.remove('open');toggle?.setAttribute('aria-expanded','false')});
    const x=share.querySelector('[data-share-x]');
    if(x)x.href='https://twitter.com/intent/tweet?url='+encodeURIComponent(url)+'&text='+encodeURIComponent(title);
    const fb=share.querySelector('[data-share-facebook]');
    if(fb)fb.href='https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url);
    const pin=share.querySelector('[data-share-pinterest]');
    if(pin)pin.href='https://pinterest.com/pin/create/button/?url='+encodeURIComponent(url)+'&description='+encodeURIComponent(title);
    const email=share.querySelector('[data-share-email]');
    if(email)email.href='mailto:?subject='+encodeURIComponent(title)+'&body='+encodeURIComponent(url);
    share.querySelector('[data-share-copy]')?.addEventListener('click',()=>{
      navigator.clipboard?.writeText(url);
      toast('Link copied');
    });
  });
  document.querySelectorAll('[data-carousel]').forEach(car=>{
    const track=car.querySelector('[data-carousel-track]');
    const step=()=>(track.querySelector('.carousel-slide')?.offsetWidth||260)+16;
    car.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    car.querySelector('[data-carousel-next]')?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  });
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduceMotion){
    document.querySelectorAll('[data-announcement]').forEach(bar=>{
      const msgs=[...bar.querySelectorAll('[data-announcement-msg]')];
      if(msgs.length<2)return;
      let i=0;
      setInterval(()=>{
        msgs[i].classList.remove('active');
        i=(i+1)%msgs.length;
        msgs[i].classList.add('active');
      },4000);
    });
    document.querySelectorAll('.product-grid, .category-grid, .value-grid, .review-grid, .social-grid, .all-collections-row').forEach(grid=>{
      [...grid.children].forEach((child,i)=>{
        child.classList.add('reveal');
        child.style.transitionDelay=(Math.min(i,6)*60)+'ms';
      });
    });
    document.querySelectorAll('.section-head, .hero-copy, .hero-visual, .moment-copy, .about-hero, .about-story, .contact-info, .contact-form-wrap, .promo-inner, .collection-head').forEach(el=>el.classList.add('reveal'));
    const revealEls=document.querySelectorAll('.reveal');
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){entry.target.classList.add('in-view');io.unobserve(entry.target)}
        });
      },{threshold:0.15,rootMargin:'0px 0px -40px 0px'});
      revealEls.forEach(el=>io.observe(el));
    }else{
      revealEls.forEach(el=>el.classList.add('in-view'));
    }
    const RV_KEY='nevora_recently_viewed',RV_MAX=8;
    const rvTracker=document.querySelector('[data-track-product]');
    const currentHandle=rvTracker?rvTracker.dataset.trackProduct:null;
    if(currentHandle){
      let list=[];
      try{list=JSON.parse(localStorage.getItem(RV_KEY))||[]}catch(e){list=[]}
      list=list.filter(h=>h!==currentHandle);
      list.unshift(currentHandle);
      try{localStorage.setItem(RV_KEY,JSON.stringify(list.slice(0,RV_MAX)))}catch(e){}
    }
    const rvSection=document.querySelector('[data-recently-viewed]');
    if(rvSection){
      const grid=rvSection.querySelector('[data-recently-viewed-grid]');
      let list=[];
      try{list=JSON.parse(localStorage.getItem(RV_KEY))||[]}catch(e){list=[]}
      list=list.filter(h=>h!==currentHandle).slice(0,4);
      if(list.length){
        Promise.all(list.map(handle=>fetch('/products/'+handle+'.js').then(r=>r.ok?r.json():null).catch(()=>null)))
          .then(products=>{
            products=products.filter(Boolean);
            if(!products.length)return;
            grid.innerHTML=products.map(p=>{
              const price=(p.price/100).toFixed(2);
              const compareAt=p.compare_at_price&&p.compare_at_price>p.price?(p.compare_at_price/100).toFixed(2):null;
              const pct=compareAt?Math.round((p.compare_at_price-p.price)/p.compare_at_price*100):null;
              const variantId=p.variants&&p.variants[0]?p.variants[0].id:'';
              const title=p.title.replace(/</g,'&lt;').replace(/"/g,'&quot;');
              const img=p.featured_image?p.featured_image+(p.featured_image.includes('?')?'&':'?')+'width=700':'';
              return '<article class="product-card">'+
                '<a class="product-media" href="'+p.url+'">'+(img?'<img src="'+img+'" loading="lazy" alt="'+title+'">':'')+(pct?'<span class="badge">Save '+pct+'%</span>':'')+'</a>'+
                '<div class="product-info"><a href="'+p.url+'"><h3>'+title+'</h3></a><div class="price">$'+price+(compareAt?' <s>$'+compareAt+'</s>':'')+'</div>'+
                (p.available?'<form method="post" action="/cart/add.js" data-quick-add><input type="hidden" name="id" value="'+variantId+'"><button class="quick-add" type="submit">Quick add</button></form>':'<button class="quick-add" disabled>Sold out</button>')+
                '</div></article>';
            }).join('');
            rvSection.hidden=false;
          });
      }
    }
  }
});
